module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/banner_mobile.fa72d3a0.jpg";